import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaRegClock, FaBookOpen } from 'react-icons/fa';

import Footer from './footer';
import Header from './header';
import apiUrl from './base_url';

import '../components/cssfile/question_paper.css';
import '../components/cssfile/blog.css';

class Blog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      other: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    axios
      .get(apiUrl + 'serverside/latest_job.php')
      .then((response) => {
        const articles = Array.isArray(response.data)
          ? response.data.filter(
              (item) =>
                item.category === 'other' &&
                item.exam_category === 'other'
            )
          : [];

        this.setState({
          other: articles,
          loading: false,
          error: null,
        });
      })
      .catch((error) => {
        console.error('Error fetching articles:', error);

        this.setState({
          error: 'There was an error fetching the articles.',
          loading: false,
        });
      });
  }

  createSlug = (text) => {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  getShortTitle = (title) => {
    const safeTitle = String(title || '');

    if (safeTitle.length <= 90) {
      return safeTitle;
    }

    return safeTitle.substring(0, 90) + '...';
  };

  renderArticle = (item, index) => {
    const topicName = item.topic_name || 'Untitled Article';

    const slug = this.createSlug(topicName);

    return (
      <Link
        key={item.id || index}
        to={{
          pathname: `/job_detail/${slug}`,
          state: {
            url: item.url,
            id: item.id,
          },
        }}
        className="blog-article-link"
      >
        <article className="blog-article-item">

          <div className="blog-article-number">
            {String(index + 1).padStart(2, '0')}
          </div>

          <div className="blog-article-icon">
            <FaBookOpen />
          </div>

          <div className="blog-article-content">

            <div className="blog-article-top">

              <span className="blog-article-category">
                ARTICLE
              </span>

              {index < 3 && (
                <span className="blog-new-badge">
                  NEW
                </span>
              )}

            </div>

            <h3 className="blog-article-title">
              {this.getShortTitle(topicName)}
            </h3>

            <div className="blog-article-meta">
              <FaRegClock />
              <span>Latest Published Article</span>
            </div>

          </div>

          <div className="blog-article-arrow">
            <FaArrowRight />
          </div>

        </article>
      </Link>
    );
  };

  renderSection = (title, items) => {
    return (
      <section className="blog-section">

        <div className="blog-section-header">

          <div className="blog-section-heading">

            <span className="blog-section-label">
              KNOWLEDGE CENTER
            </span>

            <h1>
              {title}
            </h1>

            <p>
              Stay updated with the latest articles,
              information and useful resources.
            </p>

          </div>

          <div className="blog-section-count">
            <strong>
              {items.length}
            </strong>

            <span>
              Articles
            </span>
          </div>

        </div>


        <div className="blog-article-list">

          {items.length > 0 ? (

            items
              .slice(0, 50)
              .map((item, index) =>
                this.renderArticle(item, index)
              )

          ) : (

            <div className="blog-empty">

              <div className="blog-empty-icon">
                <FaBookOpen />
              </div>

              <h3>
                No Articles Available
              </h3>

              <p>
                There are currently no published articles.
                Please check again later.
              </p>

            </div>

          )}

        </div>

      </section>
    );
  };

  render() {
    const {
      other,
      loading,
      error,
    } = this.state;

    if (loading) {
      return (
        <div className="blog-page">

          <Header />

          <main className="blog-loading">

            <div className="blog-loader" />

            <h3>
              Loading Articles
            </h3>

            <p>
              Please wait while we fetch the latest articles.
            </p>

          </main>

          <Footer />

        </div>
      );
    }

    if (error) {
      return (
        <div className="blog-page">

          <Header />

          <main className="blog-error">

            <div className="blog-error-icon">
              !
            </div>

            <h3>
              Unable to Load Articles
            </h3>

            <p>
              {error}
            </p>

            <button
              type="button"
              className="blog-retry-button"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>

          </main>

          <Footer />

        </div>
      );
    }

    return (
      <div className="blog-page">

        <Header />

        {/* ================= HERO ================= */}

        <section className="blog-hero">

          <div className="blog-hero-overlay">

            <div className="container">

              <div className="blog-hero-content">

                <span className="blog-hero-label">
                  ERWATODAY
                </span>

                <h1>
                  Latest Articles
                </h1>

                <p>
                  Explore useful articles, updates and
                  information to stay informed.
                </p>

                <div className="blog-hero-stats">

                  <div className="blog-stat">
                    <strong>
                      {other.length}
                    </strong>

                    <span>
                      Published Articles
                    </span>
                  </div>

                  <div className="blog-stat-divider" />

                  <div className="blog-stat">
                    <strong>
                      50+
                    </strong>

                    <span>
                      Topics & Updates
                    </span>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>


        {/* ================= ARTICLES ================= */}

        <main className="container blog-container">

          <div className="row justify-content-center">

            <div className="col-lg-10 col-xl-9">

              {this.renderSection(
                'Latest Published Articles',
                other
              )}

            </div>

          </div>

        </main>

        <Footer />

      </div>
    );
  }
}

export default Blog;